import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IFilterPaginationDto } from '../models';
import {
  IDeviceTokenDto,
  INotificationDto,
} from '../models/notification.model';

@Injectable()
export class NotificationService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getAppNotificationList(
    model: IFilterPaginationDto
  ): Observable<INotificationDto[]> {
    return this.post(`admin/notification/app/list`, model);
  }

  public saveAppNotification(
    model: INotificationDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/notification/app/save`, model);
  }

  public changeAppNotificationStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/notification/app/${id}`, null);
  }

  public deleteAppNotification(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/notification/app/${id}`);
  }

  public getPushNotificationList(
    model: IFilterPaginationDto
  ): Observable<INotificationDto[]> {
    return this.post(`admin/notification/push/list`, model);
  }

  public savePushNotification(
    model: INotificationDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/notification/push/save`, model);
  }

  public deletePushNotification(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/notification/push/${id}`);
  }

  public sendPushNotification(
    model: IDeviceTokenDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/notification/merchant`, model);
  }
}
